<template>
  <router-link
    :to="{
      name: 'ShopProductDetail',
      params: {
        id: (product.register && product.register.slug) || product.registerId,
        productId: product.id,
      },
    }"
    class="text-decoration-none d-block m-1"
  >
    <b-card
      no-body
      class="p-0 p-md-1 border-0 rounded-lg text-left custom-product-item"
    >
      <div style="position: relative">
        <b-card-img-lazy
          :src="product.imageUrl || placeholder"
          :blank-src="placeholder"
          :alt="product.name"
          class="rounded-lg"
        >
        </b-card-img-lazy>
        <span
          v-if="product.isOutOfStock"
          style="position: absolute; bottom: 0; right: 0"
        >
          <b-badge variant="primary">Out of Stock</b-badge>
        </span>
      </div>

      <div class="px-1">
        <template v-if="simpleItem">
          <p
            class="mt-3 text-muted mb-0 custom-card-product-name overflow-hidden"
            style="height: 20px"
            :title="product.name"
          >
            {{ product.name }}
            <span v-if="product.label"> ({{ product.label }})</span>
          </p>

          <div class="mb-0 custom-card-product-price">
            <div class="mb-0 align-items-center" :style="color">
              <!-- {{product.register.isQuotation}} -->
              <template v-if="!product.register.isQuotation">
                <template
                  v-if="product.isSpecialOffer && product.specialOfferPrice"
                >
                  <p class="mb-0">
                    {{ product.specialOfferPrice | numFormat | currencyFilter }}
                    <small class="d-block text-muted">
                      <b-badge variant="primary">Special Offer</b-badge>
                    </small>
                  </p>
                </template>
                <template v-else-if="product.isPromo && product.promoPrice">
                  <p class="mb-0">
                    {{ product.promoPrice | numFormat | currencyFilter }}
                    <small class="d-block text-muted">
                      <del>
                        {{
                          (loggedIn ? product.minPrice : product.maxPrice)
                            | numFormat
                            | currencyFilter
                        }}
                      </del>
                    </small>
                  </p>
                  <div class="text-muted"></div>
                </template>
                <template v-else>
                  <p class="mb-1 pb-3">
                    {{
                      (loggedIn ? product.minPrice : product.maxPrice)
                        | numFormat
                        | currencyFilter
                    }}
                  </p>
                </template>
              </template>
              <template v-else>
                <p class="my-2 pt-2">
                  <small class="d-block text-muted">
                    <b-badge variant="secondary">Quotation</b-badge>
                  </small>
                </p>
              </template>
            </div>
          </div>
        </template>
        <template v-else>
          <p
            class="text-primary text-center mt-2 mb-0 custom-card-product-price"
          >
            <template
              v-if="product.isSpecialOffer && product.specialOfferPrice"
            >
              {{ product.specialOfferPrice | numFormat | currencyFilter }}
            </template>
            <template v-else-if="product.isPromo && product.promoPrice">
              {{ product.promoPrice | numFormat | currencyFilter }}
            </template>
            <template v-else>
              <p class="mb-0">
                {{
                  (loggedIn ? product.minPrice : product.maxPrice)
                    | numFormat
                    | currencyFilter
                }}
              </p>
            </template>
          </p>

          <p
            class="text-muted mb-0 custom-card-product-name"
            :title="product.name"
          >
            {{ product.name }}
          </p>
        </template>
        <div
          class="my-0 px-0 py-1 d-inline-flex align-center"
          style="font-weight: 500;font-size: 16px"
        >
          <span class="text-secondary mr-2"> Available Qty: </span>
          <span style="color: #2792aa; font-weight: 700">
            {{ product.availableQty }}
          </span>
        </div>

        <!-- <div v-if="showRating" class="my-1 text-muted">
          <span
            class="rating"
            v-for="(avgRate, idx) in 5"
            :key="`prod-avg-product${product.id}-${idx}`"
          >
            <b-icon-star-fill
              v-if="avgRate <= product.avgRating"
            ></b-icon-star-fill>
            <b-icon-star-half
              v-else-if="
                avgRate > product.avgRating && avgRate < product.avgRating + 1
              "
            ></b-icon-star-half>
            <b-icon-star class="empty-star" v-else></b-icon-star>
          </span>
          <span class="rating-avg">({{ product.avgRating }})</span>
        </div> -->

        <p v-if="showSeller" class="text-truncate text-muted">
          {{ product.register.companyName }}
        </p>

        <b-button
          @click.prevent="addProductToInquire(product)"
          block
          variant="primary"
          :disabled="product.isOutOfStock"
        >
          <div class="d-flex align-items-center justify-content-center">
            <b-icon-cart-plus aria-hidden="true"></b-icon-cart-plus>
            <span class="ml-2"> {{ $t('favList_addToInquireBtnLabel') }}</span>
          </div>
        </b-button>
      </div>
    </b-card>
  </router-link>
</template>

<script>
import {
  BCard,
  BCardImgLazy,
  BBadge,
  // BIconStar,
  // BIconStarFill,
  // BIconStarHalf,
  BButton,
  BIconCartPlus,
} from 'bootstrap-vue';

export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
    showSeller: {
      type: Boolean,
      default: false,
    },
    simpleItem: {
      type: Boolean,
      default: true,
    },
    showRating: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: '#ff7200',
    },
  },
  components: {
    BCard,
    BCardImgLazy,
    BBadge,
    // BIconStar,
    // BIconStarFill,
    // BIconStarHalf,
    BButton,
    BIconCartPlus,
  },
  data: () => ({
    placeholder: require('../assets/images/yoma-placeholder.png'),
    shops: [],
    isAddingToCart: false,
    isAddingToInquire: false,
  }),
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
  },
  methods: {
    // async addProductToCart(product) {
    //   if (!this.loggedIn) {
    //     this.$router.push({
    //       name: 'Login',
    //       params: { nextUrl: this.$route.fullPath },
    //     });
    //   } else {
    //     this.isAddingToCart = true
    //     await this.$store.dispatch('cart/addToCart', {
    //       ...product,
    //       qty: this.quantity > 0 ? this.quantity : 1,
    //     });

    //     this.$notify({
    //       type: 'success',
    //       text: `${product.name} ${this.$t('cart_addToCartMsg')}`,
    //     });
    //     this.isAddingToCart = false;
    //   }
    // },

    async addProductToInquire(product) {
      if (!this.loggedIn) {
        this.router.push({
          name: 'Login',
          params: { nextUrl: this.$route.fullPath },
        });
      } else {
        this.isAddingToInquire = true;
        await this.$store.dispatch('inquire/addToInquire', {
          ...product,
          qty: this.quantity > 0 ? this.quantity : 1,
        });
        this.$notify({
          type: 'success',
          text: `${product.name} ${this.$t('inquire_addToInquireMsg')}`,
        });
        this.isAddingToInquire = false;
      }
    },
  },
};
</script>

<style></style>
